import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TareaHuCu } from 'src/app/shared/model/gestion-proyectos/tareasCuHu';
import swal from 'sweetalert2';
import { HucuService } from '../hucu.service';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { IncidenciasService } from 'src/app/incidencias/incidencias.service';
import { TareaDiaria } from 'src/app/shared/model/tarea/tareaDiaria.model';
import { EstatusTareaEnum } from 'src/app/utilerias/enums/estatusTareaDiariaEnum';
import { CasoDeUsoBean } from 'src/app/shared/casosDeUso';
import { HistoriaDeUsuario } from 'src/app/shared/historiaUsuario';
import { concatMap, firstValueFrom, tap } from 'rxjs';
import { AuthService } from 'src/app/security/auth.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { NgFor, NgIf } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { SoloNumeroDirective } from '../../utilerias/directives/solo-numero.directive';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-task',
    templateUrl: './modal-task.component.html',
    styleUrls: ['./modal-task.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, NgFor, MatOption, SoloNumeroDirective, NgIf, MatButton]
})
export class ModalTaskComponent {
  objetoTask: TareaHuCu;
  listaTareas: Array<TareaHuCu>;
  estatus = [
    { valor: EstatusTareaEnum.PENDIENTE },
    { valor: EstatusTareaEnum.ACTIVO },
    { valor: EstatusTareaEnum.TERMINADO },
    { valor: EstatusTareaEnum.PAUSADO }
  ];

  tipoTarea = [
    {tipo: 'CU'},
    {tipo: 'HU'}
  ]

  taksGroup: FormGroup;

  @Input() datosCu: any;
  @Input() id_proyecto: number;
  @Input() dialogRef: MatDialogRef<ModalTaskComponent>


  listaDEmpleados: Array<Empleado>;
  tarea: TareaDiaria = new TareaDiaria();
  listaCu: Array<CasoDeUsoBean>;
  listaHu: Array<HistoriaDeUsuario>;
  idtipoCu: number;
  idtipoHu: number;
  usuarioEnSesion: number;


  constructor(private hucuService: HucuService, private serviceProy: ProyectosService, private incidenciaService: IncidenciasService,
    @Inject(MAT_DIALOG_DATA) public data: any, private formbuilder: FormBuilder, private authS: AuthService,
    private msg: Msg
  ) { }

  ngOnInit() {
    this.authS.getSesion().subscribe(res => {
      this.usuarioEnSesion = res.usuario.id;
    });
    if (this.datosCu != null) {
      this.objetoTask = this.datosCu;
      this.consultaTareas(this.datosCu.id);
    } else {
      this.objetoTask = new TareaHuCu();
      this.tarea = new TareaDiaria();
      this.consultaEmpleadosDos();
    }
    this.consultaCasosDUso(this.id_proyecto.toString());
    this.consultaHuXProyecto(this.id_proyecto.toString());
    this.inicializarFormulario();
  }

  inicializarFormulario() {
    this.taksGroup = this.formbuilder.group({
      tituloCtrl: new FormControl('', Validators.required),
      descripcionCtrl: new FormControl('', Validators.required),
      estatusCtrl: new FormControl('', Validators.required),
      tiempoEstimadoCtrl: new FormControl('', Validators.required),
      tiempoRealCtrl: new FormControl(''),
      clasificacionCtrl: new FormControl('', Validators.required),
      tipoCtrl: new FormControl('', Validators.required),
      idtipo: new FormControl('', Validators.required),
      responsableCtrl: (''),
    });
  }

  consultaTareas(id: number) {
    this.consultaEmpleados().pipe(
      concatMap(() => this.hucuService.consultaTsk(id))
    ).subscribe(res => {
      this.listaTareas = res.list;
      if (this.listaTareas.length > 0) {
        this.objetoTask = this.listaTareas[0];
        const resp = this.listaTareas[0].responsable;
        if (this.listaDEmpleados !== null && this.listaDEmpleados !== undefined) { 
          const empleadoResponsable = this.listaDEmpleados.filter(empleado => empleado.usuario.id === resp);
          if (empleadoResponsable ) { 
            if (empleadoResponsable && empleadoResponsable.length > 0) {
             this.objetoTask.responsable = empleadoResponsable[0].idUsuario;
            }
            
          }
        }
      }
      if (this.objetoTask.tipo !== undefined && this.objetoTask.tipo == 'CU') {
        const idTipoSeleccionado = this.listaCu.filter(tipoId => tipoId.id === this.listaTareas[0].idtipo);
          if (idTipoSeleccionado && idTipoSeleccionado.length > 0) { 
            this.objetoTask.idtipo = idTipoSeleccionado[0].id;
          }
        }
        if (this.objetoTask.tipo !== undefined && this.listaHu.length > 0 && this.objetoTask.tipo == 'HU') {
          const idTipoSeleccionado = this.listaHu.filter(tipoId => tipoId.id === this.listaTareas[0].idtipo);
          if (idTipoSeleccionado && idTipoSeleccionado.length > 0) { 
            this.objetoTask.idtipo = idTipoSeleccionado[0].id;
          }
        }
    });
  }
  
  consultaEmpleados() {
    return this.serviceProy.consultaEmpleados().pipe(
      tap(res => {
        this.listaDEmpleados = res.list;
      })
    );
  }

  consultaEmpleadosDos() {
    this.serviceProy.consultaEmpleados().subscribe(res => {
      this.listaDEmpleados = res.list;
    });
  }
  
  

  public guardarTask() {
    this.hucuService.guardarTask(this.objetoTask).subscribe(
      (respuesta) => {
        if(respuesta.pCodRetorno == "00000"){
          swal.fire({
            text: 'Tarea registrada con éxito.',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger',
            },
            icon: 'success',
          }).then((result) => {
            this.dialogRef.close(true);
          });
          if(this.objetoTask.responsable === this.usuarioEnSesion ){
            if (this.objetoTask.estatus === 'ACTIVO' && this.objetoTask.responsable !== null && this.objetoTask.responsable === this.usuarioEnSesion) {
              this.guardar();
            }
          }
        }else{
          this.msg.warningCall("Lo sentimos, no se pudo guardar la tarea", 'Mensaje', null);
        }
      },
      (error) => {
      }
    );
  }
  
  public guardar() {
    if (this.objetoTask.estatus === 'ACTIVO' && this.objetoTask.responsable !== null) {
      this.tarea.nombre = this.objetoTask.nombre;
      this.tarea.descripcion = this.objetoTask.descripcion;
      this.tarea.idUsuario = this.objetoTask.responsable;
      this.tarea.idProyecto = this.id_proyecto.toString();
      firstValueFrom(this.incidenciaService.obtenerElementoPorCampoPost(UrlConstantes.OPERACION_TAREA_DIARIA, this.tarea))
        .then((res) => {
          let tareaRes = res as TareaDiaria;
          this.dialogRef.close(true); 
        })
        .catch(() => {
        });
    }
  }

  consultaCasosDUso(idProyecto: string) {
    this.hucuService.consultaCuXProyecto(idProyecto).subscribe(res => {
      this.listaCu = res.list;
   
      });
    
  }
  

  consultaHuXProyecto(idProyecto: string) {
    this.hucuService.consultaHuXProyecto(idProyecto).subscribe(res => {
      this.listaHu = res.list;
    });
  }


}
